import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=aa4bbe16&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=js&"
export * from "./NavItem.vue?vue&type=script&lang=js&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=aa4bbe16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4bbe16",
  null
  
)

export default component.exports